import { useNavigate } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Footer() {
  const navigate = useNavigate();

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-950">
                青柠影院
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              最新电影在线观看平台，提供海量高清电影全集免费观看。每日更新，追新片快人一步。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors"
                aria-label="B站"
              >
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Movie Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="/category/dongzuo" className="hover:text-primary-500 transition-colors">电影分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <button
                    onClick={() => handleCategoryClick(cat.slug)}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-1.5"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* More Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">&nbsp;</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <button
                    onClick={() => handleCategoryClick(cat.slug)}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-1.5"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="/about" className="hover:text-primary-500 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="/about#brand"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/about");
                  }}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  品牌介绍
                </a>
              </li>
              <li>
                <a
                  href="/about#reputation"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/about");
                  }}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  用户口碑
                </a>
              </li>
              <li>
                <a
                  href="/about#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/about");
                  }}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  联系我们
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  回到首页
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-background-200">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 青柠影院. 本站内容仅供学习交流使用，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
                用户协议
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}